import script from "./SentenceView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SentenceView.vue?vue&type=script&setup=true&lang=ts"

import "./SentenceView.vue?vue&type=style&index=0&id=c7096632&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7096632"]])

export default __exports__